import { toast as _toast } from '@vectorworks/vcs-ui/dist/lib/Toast/Toast';
import { NOTIFICATIONS } from './toastList';

export const toast = Settings.IN_WEB_VIEW
    ? () => {}
    : (notificationName, ...args) => _toast(NOTIFICATIONS[notificationName], ...args);
